// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "1258560-dirty",
    "hash": "1258560",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "1258560-dirty",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
